import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const RegularCaseButton = styled(Button)(({ theme }) => ({
  textTransform: 'none', // Override the text-transform property to preserve regular case
}));

export default RegularCaseButton;